import { render, staticRenderFns } from "./OverviewPetty.vue?vue&type=template&id=7c7609d1&scoped=true&"
import script from "./OverviewPetty.vue?vue&type=script&lang=js&"
export * from "./OverviewPetty.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPetty.vue?vue&type=style&index=0&id=7c7609d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7609d1",
  null
  
)

export default component.exports